var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmcg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.5L15 12.5L21 16.5V8.5Z",
    stroke: "#2D3036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 6.5H4.6C3.71634 6.5 3 7.26751 3 8.21429V16.7857C3 17.7325 3.71634 18.5 4.6 18.5H13.4C14.2837 18.5 15 17.7325 15 16.7857V8.21429C15 7.26751 14.2837 6.5 13.4 6.5Z",
    stroke: "#2D3036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmcg);
export default __webpack_public_path__ + "static/media/fmcg.7fccec6fdcda5a7a20c6d0ef79301286.svg";
export { ForwardRef as ReactComponent };